import { helper } from '@ember/component/helper';

export function arrayAt([array, index]) {
  return array?.at(index);
}

export default helper(arrayAt);
